import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PolitiqueConfidentialitePage() {
  const handleDownload = () => {
    const content = document.getElementById('legal-content');
    if (!content) return;

    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <title>Politique de Confidentialité - Clinique Sainte Famille</title>
          <style>
            @page { 
              margin: 2cm; 
              size: A4;
            }
            body { 
              font-family: Arial, sans-serif; 
              padding: 0; 
              margin: 0;
              line-height: 1.6; 
              color: #333; 
              font-size: 12px;
            }
            h1 { 
              color: #1e40af; 
              font-size: 24px; 
              margin-bottom: 20px; 
              page-break-after: avoid;
            }
            h2 { 
              color: #1e40af; 
              font-size: 18px; 
              margin-top: 25px; 
              margin-bottom: 12px; 
              page-break-after: avoid;
            }
            h3 { 
              color: #1e40af; 
              font-size: 14px; 
              margin-top: 15px; 
              margin-bottom: 8px; 
              page-break-after: avoid;
            }
            p, li { 
              margin-bottom: 8px; 
              page-break-inside: avoid;
            }
            ul { 
              margin-left: 20px; 
            }
            table { 
              width: 100%; 
              border-collapse: collapse; 
              margin: 15px 0; 
              page-break-inside: avoid;
            }
            th, td { 
              border: 1px solid #ddd; 
              padding: 6px; 
              text-align: left; 
              font-size: 11px;
            }
            th { 
              background-color: #f3f4f6; 
            }
            .info-box { 
              background: #f8f9fa; 
              padding: 12px; 
              border-left: 4px solid #1e40af;
              margin: 12px 0; 
              page-break-inside: avoid;
            }
            .grid { 
              display: block; 
            }
            .grid > div { 
              margin-bottom: 10px; 
              page-break-inside: avoid;
            }
            section { 
              page-break-inside: avoid; 
              margin-bottom: 20px;
            }
            @media print {
              body { print-color-adjust: exact; }
            }
          </style>
        </head>
        <body>
          ${content.innerHTML}
        </body>
      </html>
    `;

    const blob = new Blob([printContent], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Politique-Confidentialite-Clinique-Sainte-Famille.html';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 100);

    const notification = document.createElement('div');
    notification.className = 'fixed bottom-4 right-4 bg-clinic-green text-white px-6 py-3 rounded-full shadow-lg z-50 flex items-center gap-2';
    notification.innerHTML = '<i class="ri-check-line"></i> Fichier téléchargé avec succès';
    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 3000);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />

      <div className="flex-1 py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6 flex items-center justify-between">
            <button
              onClick={handleDownload}
              className="flex items-center gap-2 px-6 py-3 bg-clinic-blue text-white rounded-full hover:bg-clinic-blue-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line text-lg"></i>
              Télécharger en PDF
            </button>
          </div>
          <div className="bg-white rounded-3xl shadow-xl border-2 border-clinic-blue/10 p-8 md:p-12" id="legal-content">
            <div className="mb-8">
              <div className="w-16 h-16 bg-clinic-blue/10 rounded-2xl flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-3xl text-clinic-blue"></i>
              </div>
              <h1 className="text-4xl font-bold text-clinic-blue-dark mb-2">Politique de Confidentialité</h1>
              <p className="text-gray-600">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
            </div>

            <div className="prose prose-lg max-w-none space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">1. Introduction</h2>
                <p className="text-gray-700 leading-relaxed">
                  La Clinique Sainte Famille s'engage à protéger la confidentialité et la sécurité de vos données personnelles et médicales. 
                  Cette politique de confidentialité décrit comment nous collectons, utilisons, stockons et protégeons vos informations conformément 
                  à la <strong>loi n°2017-20 du Bénin sur la protection des données personnelles</strong> et aux directives de l'<strong>Autorité de Protection des Données Personnelles (APDP)</strong>.
                </p>
                <div className="bg-clinic-blue/5 border-l-4 border-clinic-blue p-4 rounded-lg mt-4">
                  <p className="text-sm text-clinic-blue-dark">
                    <i className="ri-information-line mr-2"></i>
                    Les données médicales collectées sont traitées conformément à la loi n°2017-20 du Bénin sur la protection des données personnelles et déclarées auprès de l'APDP.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">2. Responsable du Traitement</h2>
                <div className="bg-gray-50 p-6 rounded-2xl">
                  <p className="text-gray-700"><strong>Clinique Sainte Famille</strong></p>
                  <p className="text-gray-700">99QX+7W, Cotonou Bénin</p>
                  <p className="text-gray-700">04 BP 127 lot 1862 Fifadji</p>
                  <p className="text-gray-700">Téléphone : +229 01 95 40 58 91 / +229 01 94 27 54 24</p>
                  <p className="text-gray-700">Email : clinicfam@yahoo.com</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">3. Données Collectées</h2>
                <p className="text-gray-700 mb-4">Nous collectons les catégories de données suivantes :</p>
                
                <div className="space-y-4">
                  <div className="border-l-4 border-clinic-green pl-4">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">3.1 Données d'Identification</h3>
                    <ul className="list-disc list-inside text-gray-700 space-y-1">
                      <li>Nom et prénom</li>
                      <li>Date de naissance</li>
                      <li>Adresse email et/ou numéro de téléphone</li>
                      <li>Adresse postale</li>
                    </ul>
                  </div>

                  <div className="border-l-4 border-clinic-green pl-4">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">3.2 Données Médicales</h3>
                    <ul className="list-disc list-inside text-gray-700 space-y-1">
                      <li>Historique médical et antécédents</li>
                      <li>Résultats d'examens et tests</li>
                      <li>Prescriptions et traitements</li>
                      <li>Comptes rendus de consultations</li>
                      <li>Diagnostics et suivis médicaux</li>
                    </ul>
                  </div>

                  <div className="border-l-4 border-clinic-green pl-4">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">3.3 Données de Connexion</h3>
                    <ul className="list-disc list-inside text-gray-700 space-y-1">
                      <li>Adresse IP</li>
                      <li>Dates et heures de connexion</li>
                      <li>Type de navigateur et appareil</li>
                      <li>Historique des accès au dossier médical</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">4. Finalités du Traitement</h2>
                <p className="text-gray-700 mb-4">Vos données sont utilisées exclusivement pour :</p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>La gestion de vos rendez-vous médicaux</li>
                  <li>La constitution et la mise à jour de votre dossier médical</li>
                  <li>Le suivi de vos traitements et prescriptions</li>
                  <li>La communication avec vous concernant vos soins</li>
                  <li>L'amélioration de la qualité des soins</li>
                  <li>Le respect des obligations légales et réglementaires</li>
                  <li>La sécurité et la traçabilité des accès aux données médicales</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">5. Base Légale du Traitement</h2>
                <p className="text-gray-700 mb-4">Le traitement de vos données repose sur :</p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li><strong>Votre consentement explicite</strong> pour le traitement de vos données médicales</li>
                  <li><strong>L'exécution du contrat de soins</strong> entre vous et la clinique</li>
                  <li><strong>Les obligations légales</strong> imposées par la législation béninoise en matière de santé</li>
                  <li><strong>L'intérêt vital</strong> pour la protection de votre santé</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">6. Destinataires des Données</h2>
                <p className="text-gray-700 mb-4">Vos données peuvent être partagées avec :</p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Les médecins et professionnels de santé impliqués dans vos soins</li>
                  <li>Le personnel administratif autorisé de la clinique</li>
                  <li>Les laboratoires d'analyses médicales (avec votre consentement)</li>
                  <li>Les autorités sanitaires (dans le cadre légal)</li>
                  <li>Les prestataires techniques assurant l'hébergement sécurisé des données</li>
                </ul>
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg mt-4">
                  <p className="text-sm text-yellow-800">
                    <i className="ri-alert-line mr-2"></i>
                    Aucune donnée médicale n'est vendue ou partagée à des fins commerciales.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">7. Durée de Conservation</h2>
                <div className="bg-gray-50 p-6 rounded-2xl space-y-3">
                  <p className="text-gray-700">
                    <strong>Dossiers médicaux :</strong> Conservés pendant 20 ans après la dernière consultation, conformément à la réglementation béninoise
                  </p>
                  <p className="text-gray-700">
                    <strong>Données de connexion :</strong> Conservées pendant 1 an pour des raisons de sécurité
                  </p>
                  <p className="text-gray-700">
                    <strong>Données administratives :</strong> Conservées pendant la durée de la relation de soins + 5 ans
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">8. Vos Droits</h2>
                <p className="text-gray-700 mb-4">Conformément à la loi n°2017-20, vous disposez des droits suivants :</p>
                
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-clinic-blue/5 p-4 rounded-2xl">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                      <i className="ri-eye-line mr-2 text-clinic-blue"></i>
                      Droit d'Accès
                    </h3>
                    <p className="text-sm text-gray-700">Consulter vos données personnelles et médicales</p>
                  </div>

                  <div className="bg-clinic-blue/5 p-4 rounded-2xl">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                      <i className="ri-edit-line mr-2 text-clinic-blue"></i>
                      Droit de Rectification
                    </h3>
                    <p className="text-sm text-gray-700">Corriger vos données inexactes ou incomplètes</p>
                  </div>

                  <div className="bg-clinic-blue/5 p-4 rounded-2xl">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                      <i className="ri-delete-bin-line mr-2 text-clinic-blue"></i>
                      Droit à l'Effacement
                    </h3>
                    <p className="text-sm text-gray-700">Demander la suppression de vos données (sous conditions)</p>
                  </div>

                  <div className="bg-clinic-blue/5 p-4 rounded-2xl">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                      <i className="ri-lock-line mr-2 text-clinic-blue"></i>
                      Droit de Limitation
                    </h3>
                    <p className="text-sm text-gray-700">Limiter le traitement de vos données</p>
                  </div>

                  <div className="bg-clinic-blue/5 p-4 rounded-2xl">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                      <i className="ri-download-line mr-2 text-clinic-blue"></i>
                      Droit à la Portabilité
                    </h3>
                    <p className="text-sm text-gray-700">Récupérer vos données dans un format structuré</p>
                  </div>

                  <div className="bg-clinic-blue/5 p-4 rounded-2xl">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                      <i className="ri-close-circle-line mr-2 text-clinic-blue"></i>
                      Droit d'Opposition
                    </h3>
                    <p className="text-sm text-gray-700">Vous opposer au traitement de vos données</p>
                  </div>
                </div>

                <div className="bg-clinic-green/10 border-2 border-clinic-green/30 p-6 rounded-2xl mt-6">
                  <h3 className="font-semibold text-clinic-blue-dark mb-3">Pour exercer vos droits :</h3>
                  <p className="text-gray-700 mb-2">Contactez-nous par email à <strong>clinicfam@yahoo.com</strong> ou par courrier à notre adresse.</p>
                  <p className="text-sm text-gray-600">Nous vous répondrons dans un délai maximum de 30 jours.</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">9. Sécurité des Données</h2>
                <p className="text-gray-700 mb-4">Nous mettons en œuvre des mesures techniques et organisationnelles pour protéger vos données :</p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Chiffrement des données sensibles (SSL/TLS)</li>
                  <li>Hébergement sécurisé certifié pour les données de santé</li>
                  <li>Contrôle d'accès strict et authentification renforcée</li>
                  <li>Journalisation de tous les accès aux dossiers médicaux</li>
                  <li>Sauvegardes régulières et plan de continuité d'activité</li>
                  <li>Formation du personnel aux règles de confidentialité</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">10. Cookies et Technologies Similaires</h2>
                <p className="text-gray-700 mb-4">
                  Notre plateforme utilise des cookies essentiels pour assurer son bon fonctionnement et la sécurité de vos données. 
                  Pour plus d'informations, consultez notre <a href="/gestion-cookies" className="text-clinic-blue hover:underline font-semibold">Politique de Gestion des Cookies</a>.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">11. Réclamations</h2>
                <p className="text-gray-700 mb-4">
                  Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de :
                </p>
                <div className="bg-gray-50 p-6 rounded-2xl">
                  <p className="text-gray-700 font-semibold mb-2">Autorité de Protection des Données Personnelles (APDP)</p>
                  <p className="text-gray-700">République du Bénin</p>
                  <p className="text-gray-700">Site web : <a href="https://apdp.bj" target="_blank" rel="noopener noreferrer" className="text-clinic-blue hover:underline">www.apdp.bj</a></p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">12. Modifications</h2>
                <p className="text-gray-700">
                  Cette politique de confidentialité peut être mise à jour. Toute modification substantielle vous sera notifiée 
                  par email ou via notre plateforme. La date de dernière mise à jour est indiquée en haut de ce document.
                </p>
              </section>

              <section className="bg-clinic-blue/5 p-6 rounded-2xl border-2 border-clinic-blue/20">
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">Contact</h2>
                <p className="text-gray-700 mb-4">
                  Pour toute question concernant cette politique de confidentialité ou le traitement de vos données :
                </p>
                <div className="space-y-2 text-gray-700">
                  <p><i className="ri-mail-line mr-2 text-clinic-blue"></i><strong>Email :</strong> clinicfam@yahoo.com</p>
                  <p><i className="ri-phone-line mr-2 text-clinic-blue"></i><strong>Téléphone :</strong> +229 01 95 40 58 91</p>
                  <p><i className="ri-map-pin-line mr-2 text-clinic-blue"></i><strong>Adresse :</strong> 99QX+7W, Cotonou Bénin - 04 BP 127 lot 1862 Fifadji</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
